module.exports = __webpack_public_path__ + "static/media/5.6c0efa20.png";